export function resolveFileUrl(path: string = undefined) {
    let basePath = 'api/_files';
    if (!path) {
        return basePath
    }
    return `${basePath}/${path}`;
}